import styled from 'styled-components'

const CreateBlogDialogSuccessMessageUi = styled.span`
  font-size: 16px;
  color: #797f89;
  margin-right: 5px;
`

export default CreateBlogDialogSuccessMessageUi
